import { HttpBadStatusCodeError, TPrimitives } from '@cian/peperrors/shared';
import { setOnbordingData } from '.';
import {
  fetchGetOnboarding,
  TGetOnboardingResponse
} from '../../repositories/price-estimator/v1/get-onboarding';
import { fetchMarkOnboardingAsViewed } from '../../repositories/price-estimator/v1/mark-onboarding-as-viewed';
import { TThunkAction } from '../../types/redux';

export function getOnbording(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    try {
      const res = (await fetchGetOnboarding({
        httpApi,
      })) as TGetOnboardingResponse;

      if (res.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          domain: 'onbording/getOnbording.ts',
          statusCode: res.statusCode,
          message: res.response.message as string,
          details: { errors: res.response.errors as unknown as TPrimitives[] },
        });
      }

      dispatch(setOnbordingData(res.response.onboarding));
    } catch (error) {
      if (error instanceof HttpBadStatusCodeError) {
        logger.warning('Bad req /v1/get-onboarding/', { details: error.printDetails() });
      } else {
        logger.error(error, {
          message: 'Failed to get onbording',
        });
      }
    }
  };
}

export function markOnboardingAsViewed(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    try {
      const res = (await fetchMarkOnboardingAsViewed({
        httpApi,
      })) as TGetOnboardingResponse;

      if (res.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          domain: 'onbording/saveOnbording.ts',
          statusCode: res.statusCode,
          message: res.response.message as string,
          details: { errors: res.response.errors as unknown as TPrimitives[] },
        });
      }
    } catch (error) {
      if (error instanceof HttpBadStatusCodeError) {
        logger.warning('Bad req /v1/mark-onboarding-as-viewed/', { details: error.printDetails() });
      } else {
        logger.error(error, {
          message: 'Failed to save user onbording',
        });
      }
    }
  };
}
